!function(window) {
// babel-polyfills
// require("babel-polyfill");


/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
jQuery.cookie = function (name, value, options) {
	if (typeof value != "undefined") {
		options = options || {};
		if (value === null) {
			value = "";
			options.expires = -1
		}
		var expires = "";
		if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == "number") {
				date = new Date();
				date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
			} else {
				date = options.expires
			}
			expires = "; expires=" + date.toUTCString()
		}
		var path = options.path ? "; path=" + (options.path) : "";
		var domain = options.domain ? "; domain=" + (options.domain) : "";
		var secure = options.secure ? "; secure" : "";
		document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("")
	} else {
		var cookieValue = null;
		if (document.cookie && document.cookie != "") {
			var cookies = document.cookie.split(";");
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				if (cookie.substring(0, name.length + 1) == (name + "=")) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break
				}
			}
		}
		return cookieValue
	}
};

require("../jquery-extended-arctur")(jQuery);
require("../form.validators")(jQuery);

// URL plugin

jQuery.url = function () {
	var segments = {};
	var parsed = {};
	var options = {
		url: window.location,
		strictMode: false,
		key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
		q: {
			name: "queryKey",
			parser: /(?:^|&)([^&=]*)=?([^&]*)/g
		},
		parser: {
			strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
			loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
		}
	};
	var parseUri = function () {
		var str = decodeURI(options.url);
		var m = options.parser[options.strictMode ? "strict" : "loose"].exec(str);
		var uri = {};
		var i = 14;
		while (i--) {
			uri[options.key[i]] = m[i] || ""
		}
		uri[options.q.name] = {};
		uri[options.key[12]].replace(options.q.parser, function ($0, $1, $2) {
			if ($1) {
				uri[options.q.name][$1] = $2
			}
		});
		return uri
	};
	var key = function (key) {
		if (!parsed.length) {
			setUp()
		}
		if (key == "base") {
			if (parsed.port !== null && parsed.port !== "") {
				return parsed.protocol + "://" + parsed.host + ":" + parsed.port + "/"
			} else {
				return parsed.protocol + "://" + parsed.host + "/"
			}
		}
		return (parsed[key] === "") ? null : parsed[key]
	};
	var param = function (item) {
		if (!parsed.length) {
			setUp()
		}
		return (parsed.queryKey[item] === null) ? null : parsed.queryKey[item]
	};
	var setUp = function () {
		parsed = parseUri();
		getSegments()
	};
	var getSegments = function () {
		var p = parsed.path;
		segments = [];
		segments = parsed.path.length == 1 ? {} : (p.charAt(p.length - 1) == "/" ? p.substring(1, p.length - 1) : p.substring(1)).split("/")
	};
	return {
		setMode: function (mode) {
			strictMode = mode == "strict" ? true : false;
			return this
		},
		setUrl: function (newUri) {
			options.url = newUri === undefined ? window.location : newUri;
			setUp();
			return this
		},
		segment: function (pos) {
			if (!parsed.length) {
				setUp()
			}
			if (pos === undefined) {
				return segments.length
			}
			return (segments[pos] === "" || segments[pos] === undefined) ? null : segments[pos]
		},
		attr: key,
		param: param
	}
}();


// nastavi invisible recaptcho za vse forme in jo pokliče na submit forme

var captchaCallback = function(){
	var widgetAttr = 'data-widgetid';
	var recaptchaClass = '.g-recaptcha';
	var recaptchaRespons = '.g-recaptcha-response';
	$(recaptchaClass).each(function(index, el) {
		var form = $(el).closest("form");
		var widgetId = grecaptcha.render(el, {
			'sitekey' : jQuery(el).attr('data-sitekey'), 
			'callback' : token => {
				form.find(recaptchaRespons).val(token);
				form.submit();
			}
		});
		$(el).attr(widgetAttr, widgetId);
	});

	$('.arctur-form [type=submit]').on('click', function(ev) {
		ev.preventDefault();
		var widgetId = $(this).closest('form').find(recaptchaClass).attr(widgetAttr);
		grecaptcha.execute(widgetId);	
	});
}


//global variables for responsivness

var urlDirFull = jQuery.url.attr("directory");
var pageLng = null;


function initilizeLanguageSettings() {
	/* --- language settings --- */

	var htmlLang = $('html').attr('lang');
	if (htmlLang == 'sl') {
		pageLng = 'slo';
	} else if (htmlLang == 'it') {
		pageLng = 'ita';
	} else if (htmlLang == 'de') {
		pageLng = 'deu';
	} else if (htmlLang == 'hr') {
		pageLng = 'hrv';
	} else {
		pageLng = 'eng';
	}

	if (pageLng == 'slo' || pageLng == 'hrv') {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'];
		Date.abbrDayNames = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
		Date.monthNames = ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december'];
		Date.abbrMonthNames = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Prejšnje leto',
			TEXT_PREV_MONTH: 'Prejšnji mesec',
			TEXT_NEXT_YEAR: 'Naslednje leto',
			TEXT_NEXT_MONTH: 'Naslednji mesec',
			TEXT_CLOSE: 'Zapri',
			TEXT_CHOOSE_DATE: 'Izberi datum'
		}
	} else {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		Date.abbrDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		Date.monthNames = ['January', 'February', 'March', 'April', 'May', 'Jun', 'Julay', 'August', 'September', 'October', 'November', 'December'];
		Date.abbrMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Previews year',
			TEXT_PREV_MONTH: 'Previews month',
			TEXT_NEXT_YEAR: 'Next year',
			TEXT_NEXT_MONTH: 'Next month',
			TEXT_CLOSE: 'Close',
			TEXT_CHOOSE_DATE: 'Select date'
		}
	}
}

//initialize autocomplete - needed for responsivness so its called again on window resize

function initializeAutoComplete() {
	
	/*
	$("#input-search-mini, #input-search-main").autocomplete({
		source: "/util/string_search.php?lng=" + pageLng,
		minLength: 2,
		max: 10,
		
		select: function(hi, ho) {
			var $btn = $(this);
			setTimeout(function(){
				$btn.closest('form').submit();

			}, 50);
		},
		create: function() {
			$(this).data('ui-autocomplete')._renderItem = function (ul, item) {
				var re = new RegExp( "(" + this.term + ")", "gi" ),
					cls = this.options.highlightClass,
					template = "<strong>$1</strong>",
					label = item.label.replace( re, template ),
					$li = $( "<li/>" ).appendTo( ul );
		
				// Create and return the custom menu item content.
				$("<span/>").html(label).appendTo( $li );
				
				return $li;
			}
		},
	});
	*/
	
	$("#input-search-mini, #input-search-main").autocomplete("/util/string_search.php?lng=" + pageLng, {
		appendTo: '#search-mini-form',
		matchContains: true,
		//mustMatch: true,
		//minChars: 0,
		//multiple: true,
		//highlight: false,
		//multipleSeparator: ",",
		selectFirst: false
	});
}

// set eq height on columns with provided attr
function setEqHeight() {
	removeEqHeight();

	$("[data-eq-columns]").each(function (i, container) {
		var viewPort = $(container).attr('data-eq-columns');
		if ((viewPort && viewport().width > viewPort) || !viewPort) {
			setInternalMultiRowHeight(container);
		}

	});

	function setInternalMultiRowHeight(container) {
	
		var $children = $(container).find(">*:not([item-eq-height-set])");

		if ($children.length) {
			var parentWidth = container.getBoundingClientRect().width;
	
			// $set = 1;
	
			var $items = $(container).find(">*:not([item-eq-height-set])");
			var initialHeight = null;

			// do loop while sum of children width is smaller than container width
			var width = 0;
			var i = 0;
			var affected = [];
			while (width < parentWidth) {
				var child = $items[i];
				var $child = $(child);
				affected.push($child);
				if ($child.height() > initialHeight) {
					initialHeight = $child.height();
				}

				width += $items[i].getBoundingClientRect().width;
				i++;
			}
	
			if (initialHeight) {
				affected.forEach(function(item, index) {
					item.height(initialHeight);
					item.attr('item-eq-height-set', true);
				});
			}
	
			var items = $(container).find(">*:not([item-eq-height-set])");
			if (items.length != 0) {
				setInternalMultiRowHeight(container);
			} else {
				$(container).attr('data-eq-columns-set', '');
			}
		}
	}

	function removeEqHeight() {
		$("[data-eq-columns][data-eq-columns-set]").each(function (i, container) {
			$(container).find(">*").css("height", "auto").removeAttr('item-eq-height-set');
			$(container).removeAttr('data-eq-columns-set');
		});
	}

}

function viewport() {
	var e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return {
		width: e[a + 'Width'],
		height: e[a + 'Height']
	};
}

/**
 * Avtomatsko prikaže elemente s [data-slide-container] z izbrane smeri z izbrano hitrostjo
 * možnosti za direction: 'up','down', 'left', 'right'
 * speed je v ms
 */
function openSlideContainers() {
	var $slideContainers = $("[data-slide-container]");
	$slideContainers.hide().addClass('shown');
	$slideContainers.each(function (index, item) {
		var $direction = $(item).attr("data-slide-container");
		var $speed = $(item).attr("data-slide-speed");
		if (!$speed) {
			$speed = 1000;
		}
		if (!isNaN($speed)) {
			$speed = parseInt($speed);
		}
		$(item).show("slide", {
			direction: $direction
		}, $speed);
	});
}


/**
 * Binda element kot triger za prikazovanje druegaga elementa s pomočjo slidanja (jquery ui)
 * možnosti za direction: 'up','down', 'left', 'right'
 * speed je v ms
 */
function bindSlideAnchor() {
	$("[data-slide-anchor]").click('click', function () {
		const $container = $($(this).attr('data-slide-anchor'));
		const $anchor = $(this);

		// show container
		let $speed = $container.attr('data-slide-speed');
		if (!$speed) {
			$speed = 1000;
		}
		$speed = parseInt($speed);
		let $direction = $container.attr('data-slide-start-direction');
		if (!$direction) {
			$direction = 'up';
		}

		// hide container if already shown
		if ($container.attr('data-slide-target') !== null) {
			if ($container.hasClass('shown')) {
				$container.hide("slide", {
					direction: $direction
				}, $speed, function () {
					$container.removeClass('shown');
					$anchor.removeClass('slide-toggle-on');
				});
			} else {
				$container.show("slide", {
					direction: $direction
				}, $speed, function () {
					$container.addClass('shown');
					$anchor.addClass('slide-toggle-on');
				});
			}
		}
	});
}

// autoscrolls to element with [data-scroll-to-on-ready] attribute on window load -> 
// if you add directive [data-scroll-to-include-height] to other elements it includes its height
// to move the scroll for its height lower
function scrollToOnLoadDirective() {

	var $scrollTo = $("[data-scroll-to-on-ready]");
	if ($scrollTo.length != 0) {
		//first found
		var $item = $scrollTo[0];
		//get any items height to be added to
		var includeOtherHeight = 0;
		$("[data-scroll-to-include-height]").each(function (index, item) {
			includeOtherHeight += $(item).height();
		});
		var scrollTop = $($item).offset().top;


		$("html, body").animate({
			scrollTop: scrollTop - includeOtherHeight
		}, 600);

	}
}

/**Functions that dont require document to be ready */
initilizeLanguageSettings();


jQuery(document).ready(function () {

	var options = {
		viewport: {
			size: viewport,
			definition: {
				xs: 480,
				sm: 768,
				md: 992,
				lg: 1230
			}
		}
	}

	require('./lib/vertical-align/vertical-align');

	require("./various-utils")(jQuery);
	
	// main menu bootstrap
	require("./main-menu-bootstrap")(options);

	// main menu legacy - uncomment if needed
	//require("./main-menu-legacy");

	/* --- Search form autocomplete --- */
	initializeAutoComplete();


	/*--- poll ---*/
	jQuery("form#poll-form").submit(function () {
		var responseData = '';
		var lng = jQuery('#pollLng').val();
		if (jQuery('#multi-answers').val() != '1')
			// one answer
			responseData = jQuery("form#poll-form input:checked").val();
		else {
			// multiple answers
			jQuery("form#poll-form input:checked").each(function () {
				responseData += this.value + ' ';
			});
		}
		jQuery.post("/util/ajaxresponse.php?lng=" + lng, {
			func: "poll",
			response: responseData
		}, function (html) {
			showPoll(html);
		});
		return false;
	});

	function showPoll(htmlResponse) {
		jQuery("#poll-container").html(htmlResponse);
		jQuery("#poll-container img").each(function () {
			var tmp = jQuery(this).attr("class");
			var aVals = tmp.match(/[0-9]+$/); // get number at the end of the string
			var val = aVals[0];
			jQuery(this).animate({
				width: val + "px"
			}, 1000);
		});
	}


	/*--- FAQ ---*/
	if ($("div#faq-form-section").length) {
		$("p#faq-form-toggle").slideDown();
		$("p#faq-form-toggle").click(function () {
			$("p#faq-form-toggle").slideUp(500);
			$("div#faq-form-section").slideToggle(500);
		});
	}

	if ($("div#faq-list").length) {
		$("div#faq-list h2").click(function () {
			$(this).next("dl.faq-list").slideToggle(500);
			$(this).next("dl.faq-list").toggleClass('open');
			$(this).toggleClass('open');
		});
	}

	/* --- anchor click scrolling --- */
	$('a[href^="#"]').click(function (e) {
		// scroll to anchor if there is actually more after the # sign in the link
		if ($(this).attr('href').length > 1) {
			var scrollToElementName = $(this).attr('href').substr($(this).attr('href').indexOf("#") + 1);
			scrollTo = $("a[name=" + scrollToElementName + "]").offset().top;
			$('html, body').animate({
				scrollTop: scrollTo
			}, 500);
			e.preventDefault();
		}
	});


	/* --- Calendar --- */
	function initCalendar() {
		// advance a month
		var strId = $('#calendar-response').attr('class');

		if (strId) {
			// Get language
			var aLng = strId.split('_');
			var lng = aLng[1];

			// Load next month
			$("#cal-next-month").click(function (e) {
				var cName = $("#cal-next-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});

			// backtrack a month
			$("#cal-prev-month").click(function (e) {
				var cName = $("#cal-prev-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});
		}
	}


	/* --- Photogallery --- */
	function initPhotogallery() {
		// Apply orientation classes to the gallery list images
		if ($("#photo-gallery-list").length) {
			$("#photo-gallery-list .photo-gallery-item:not(.server-size)").each(function () {
				var image = $(this).find("img.photo-gallery");

				if (image.height() > image.width()) {
					// portrait
					$(this).addClass("portrait");
				} else {
					// lanscape
					$(this).addClass("landscape");
				}
			});
		}

		// Apply orientation classes to the gallery images
		if ($("#photo-gallery-container").length) {
			$("#photo-gallery-container .photo-gallery-item:not(.server-size)").each(function () {
				var image = $(this).find("img.photo-gallery");

				if (image.height() > image.width()) {
					// portrait
					$(this).addClass("portrait");
				} else {
					// lanscape
					$(this).addClass("landscape");
				}
			});
		}
	}

	initPhotogallery(); // initialize the photogallery



	/* --- Photolist --- */
	// resize the photolist widths for non-standard width photos
	function resizePhotolist() {
		if (jQuery("dl.photo-list").length) {
			var imgWidth = jQuery("dl.photo-list img:first").width();
			var dlWidth = jQuery("dl.photo-list").width();

			jQuery("dl.photo-list dt, dl.photo-list dd.summary").width(dlWidth - imgWidth - 10 + "px");
		}
	}

	function fixMobileTables() {
		// Wrap the tables, which are too wide with an overflow div
		$("article table").each(function () {
			var tWidth = $(this).width();
			var aWidth = $(this).parents('article').eq(0).width();
			if (tWidth > aWidth) {
				if ($(this).parent().hasClass("table-wrapper") == false) {
					$(this).wrap('<div class="table-wrapper"></div>').parent().css({
						'width': aWidth,
						'overflow': 'hidden',
						'overflow-x': 'scroll'
					});
				} else {
					$(this).parent(".table-wrapper").css({
						'width': aWidth
					});
				}
			} else {
				$(this).parent(".table-wrapper").css({
					'width': 'auto',
					'overflow': 'visible'
				});
			}
		});
	}
	fixMobileTables();

	// nova funkcija za paging
	function initNewNewsPaging() {
		var strId = $("#pagination").attr('data-url');
		window.pagObj = $('#pagination').twbsPagination({
			totalPages: $("#pagination").attr('data-total-pages'),
			visiblePages: 7,
			onPageClick: function (event, page) {
				$("#pagedNewsArchive").load("/util/ajaxresponse.php?lng=" + pageLng, {
					'func': 'pagedNewsArchive',
					'page': page-1,
					'strId': strId
				});
			}
		}).on('page', function (event, page) {
			//console.info(page + ' (from event listening)');
		});
	}
	initNewNewsPaging();
	
	
	function initCoursesPaging(search = "", selectedDate = null) {
		
		if($('#paginationCourses').data("twbs-pagination")){
			$('#paginationCourses').twbsPagination('destroy');
		}
		
		// spremeni data v pagination
		
		
		var strId = $('#paginationCourses').attr('data-url');
		var searchWord = $('#paginationCourses').attr('data-search');
		var dataId = $('.selectedCategory').attr('data-id');
		
		window.pagObj = $('#paginationCourses').twbsPagination({
			totalPages: $('#paginationCourses').attr('data-total-pages'),
			visiblePages: 7,
			paginationClass: 'customPagination',
			nextClass: 'customNext',
			prevClass: 'customPrev',
			lastClass: 'customLast',
			firstClass: 'customFirst',
			pageClass: 'customPage',
			activeClass: 'customActive',
			disabledClass: 'customDisabled',
			anchorClass: 'customAnchor',
			next: '<i class="fa fa-chevron-right" aria-hidden="true"></i>',
			prev: '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
			hideOnlyOnePage: true, 
			//initiateStartPageClick: false,
			onPageClick: function (event, page) {
				$('#coursesList').load("/util/ajaxresponse.php", {
					'func': 'pagedCoursesList',
					'page': page-1,
					'str': strId,
					'id': dataId,
					'search': searchWord
				});
			}
		}).on('page', function (event, page) {
			//console.info(page + ' (from event listening)');
		});
		
		
	}
	initCoursesPaging();
	
	
	function initCoursesPage(){
		
		var strId = $('#paginationCourses').attr('data-url');
		var searchWord = $('#paginationCourses').attr('data-search');
		var dataId = $('.selectedCategory').attr('data-id');
		
		var JSONdata = "";
		/*
		$('#coursesList').load("/util/ajaxresponse.php", {
			'func': 'pagedCoursesList',
			'page': page-1,
			'str': strId,
			'id': dataId,
			'search': searchWord
		});*/
		
		
		// setup datepicker
		
		
		
		// setup paging
		
		
		
		initCoursesPaging();
	}
	/*
	$('.categories a').on('click', function(e){
		e.preventDefault();
		$('.categories a').removeClass('selectedCategory');
		if( !($(this).hasClass("selectedCategory"))){
			$(this).addClass('selectedCategory');
		}
		initCoursesPage();
	});
	*/
	
	$('.courseInvitation').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		
		var link = $(this).attr('href');
		var values = {};
		values['dataId'] = $(this).attr('id')
		values['userId'] = $('#faceCircle').data('user-id');
		
		$.post("/util/ajaxresponse.php?lng=" + lng, {
			'func': 'hasSeenInvite',
			'id': values.dataId,
			'userId': values.userId
		}, function (response) {
			if(response){
				window.location.replace(link);
			}
		});
		
		
	});
	
	$('.clearSearch').on('click', function(e){
		e.preventDefault();
		//initCoursesPage();
		var url = window.location.href.split('?')[0];
		window.location.href = url; // hard reload
		
	});
	
	$('#faceCircleLink').on('click', function(e){
		e.preventDefault();
		$("#dropDownUser").toggle();
	});
	
	function paggingInt() {
		jQuery('.select-page').click(function (e) {
			e.preventDefault();
			var aPage = jQuery(this).attr('id').split('-');
			var strId = jQuery('#pagging-content-wraper').attr('class');

			$("#pagging-content-wraper").load("/util/ajaxresponse.php?lng=" + lng, {
				'func': 'questionsPagging',
				'page': aPage[1],
				'strId': strId
			}, function () {
				paggingInt();
			});

		})

	}
	paggingInt();
	
	
	$('.mobile').on('click', function(e){
		e.preventDefault();
		
		if( $(this).hasClass('open')){
			$(this).removeClass('open');
			const open = $(this).data("open-class");
			$('.'+open).hide();
			$(this).children().removeClass('fa-minus').addClass('fa-plus');
		}else{
			$(this).addClass('open');
			const open = $(this).data("open-class");
			$('.'+open).show();
			$(this).children('.fa').removeClass('fa-plus').addClass('fa-minus');
		}
	});
	
	$('.mobileDash').on('click', function(e){
		e.preventDefault();
		const open = $(this).data("open");
		$(open).show();
	});
	
	$('#starsInput .fa').on('click', function(e){
		e.preventDefault();
		$(this).prevAll().andSelf().removeClass("fa-heart-o");
		$(this).prevAll().andSelf().removeClass("fa-heart");
		$(this).prevAll().andSelf().addClass("fa-heart");
		
		$(this).nextAll().removeClass("fa-heart-o");
		$(this).nextAll().removeClass("fa-heart");
		$(this).nextAll().addClass("fa-heart-o");
		
		$("#starsInputField").val($(this).prevAll().andSelf().length);
	});
	
	$('#addComment').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		
		var $inputs = $('#inputComment :input');
		var values = {};
		$inputs.each(function() {
			values[this.name] = $(this).val();
			$(this).val('');
		});
		
		$.post("/util/ajaxresponse.php?lng=" + lng, {
			'func': 'addComment',
			'id': values.dataId,
			'userId': values.userId,
			'comment':values.comment,
			'grade':values.grade
		}, function (response) {
			if(response){
				$('#commentsWrapper').html(response);
			}
		});
	});
	
	$('#courseSignUp').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		
		var values = {};
		values['dataId'] = $(this).data("course-id");
		values['userId'] = $(this).data("user-id");
		
		$.post("/util/ajaxresponse.php?lng=" + lng, {
			'func': 'courseSignUp',
			'id': values.dataId,
			'userId': values.userId
		}, function (response) {
			if(response){
				$('#courseSignUp').replaceWith(response);
			}
		});
	});
	
	$('.courseSignOut').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		
		var values = {};
		values['dataId'] = $(this).data("course-id");
		values['userId'] = $(this).data("user-id");
		var element = $(this);
		
		$.post("/util/ajaxresponse.php?lng=" + lng, {
			'func': 'courseSignOut',
			'id': values.dataId,
			'userId': values.userId
		}, function (response) {
			if(response){
				$(element).closest('tr').hide();
			}
		});
	});
	
	function submitHelper() {
		$('.submit-helper').on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			$(this).closest('form').submit();
		});
	}
	submitHelper();

	$(window).scroll(function() {
		if($(window).scrollTop() == $(document).height() - $(window).height()){
			$('#cookie-button').show();
		}else{
			$('#cookie-button').hide();
		}
	});

	$('#closeButton').on('click', function(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		$('aside').hide();
	});


	function setSlick() {
		$('.exposed-course__content').slick({	
			lazyLoad: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			speed: 500,
			cssEase: 'linear',
			asNavFor: '.slider-nav',
			dots: true,
		});
		$('.slider-nav').slick({
			slidesToShow: 1,
			autoplay: true,
			prevArrow: false,
			nextArrow: false,
			autoplaySpeed: 5500,
			slidesToScroll: 1,
			asNavFor: '.exposed-course__content',
			dots: false,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			focusOnSelect: true
		});
	}
	setSlick();
	
	$(function () { // datepicker courses
		if($('#datepicker').length ){
			let allDates = $('#datepicker').data("all-dates");
			for (const position in allDates) {
				allDates[position] = new Date(allDates[position]);
			}
			let mindate = new Date(Math.min(...allDates));
			let maxdate = new Date(Math.max(...allDates));
			const today = new Date();
			
			mindate.setDate(mindate.getDate() - 1);
			maxdate.setDate(maxdate.getDate() + 1);
			
			if(mindate == 'Invalid Date') {
				mindate = today;
			}
			if(maxdate == 'Invalid Date') {
				maxdate = today;
			}
			if(mindate > today){
				mindate = today;
			}
			else if(maxdate < today){
				maxdate = today;
			}
			
			
			if( window.location.pathname.includes("arhiv") ){
				
			}
			else{
				
			}
			let searchParams = new URLSearchParams(window.location.search)
			
			let date = false;
			if(searchParams.has('selectedDate') ){
				date = new Date(searchParams.get('selectedDate'));
			}
			
			//var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
			
			const datepickerIcons = {
				time: 'fa fa-clock-o',
				date: 'fa fa-calendar',
				up: 'fa fa-chevron-up',
				down: 'fa fa-chevron-down',
				previous: 'fa fa-chevron-left',
				next: 'fa fa-chevron-right',
				today: 'fa fa-circle-thin',
				clear: 'fa fa-trash',
				close: 'fa fa-times'
			};
			
			var settingsPicker = {
				inline: true,
				sideBySide: false,
				format: 'dd. MM. YYYY',
				locale: 'sl',
				minDate: mindate,
				maxDate: maxdate,
				enabledDates: allDates,
				viewMode: 'days',
				icons: datepickerIcons,
				
			};
			
			if(!(date === false)){
				if(date < mindate) {
					date = mindate
				}
				settingsPicker.defaultDate = date;
			}
			
			// initialize datepicker
			$('#datepicker').datetimepicker(settingsPicker);
			
			// clear selected date
			$(".datepicker").on("click", ".day.active", function(e){
				e.preventDefault();
				e.stopPropagation();
				let searchParams = new URLSearchParams(window.location.search)
				if(searchParams.has('selectedDate') ){
					
					var url = window.location.href.split('?')[0];
					window.location.href = url; // hard reload
				}
			});
			
			// select date
			$('#datepicker').on('dp.change', function(e){
				e.stopPropagation();
				var dateString = moment(e.date).format('YYYY-MM-DD');
				$('#selectedDate').val(dateString);
				$(this).closest('form').submit();
			});
			
			function hideDefaultDate(){
				let searchParams = new URLSearchParams(window.location.search);
				
				if(!searchParams.has('selectedDate')){
					$('.datepicker-days .day.active').removeClass('active');
					$( "#datepicker" ).datetimepicker();
				}
			}
			hideDefaultDate();
			
			$('#datepicker').on('dp.update', function(e){
				hideDefaultDate();
			});
		}
	});

	function responsiveTable() {
		if( viewport().width < 992) {
			if($("table").closest(".table-responsive").length == 0) {
				$("table").wrap("<div class='table-responsive'></div>");
			}
			
		} else {
			if($("table").closest(".table-responsive").length != 0) {
				$("table").unwrap("<div class='table-responsive'></div>");
				$("table").remove(".table-responsive");
			}
		}
	}
	responsiveTable();

	if (!$('iframe').parent().hasClass('embed-responsive')) {
		$('iframe').wrap('<div class="embed-responsive embed-responsive-16by9">');
		$('iframe').addClass('embed-responsive-item');
	}
	
	/* --- "on load" --- */

	$('input:text').textBoxHint(); // titles to input text
	$("article a, ul.grouped-link-list a").markExternalLinks(); // adds class to external links
	initCalendar(); // initialize the calendar

	$("a[rel^='magnific']").magnificPopup({
		type: 'image',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '%curr%\/%total%'
		},
		closeBtnInside: false,
		closeOnBgClick: true
	});

	/* Wait for the whole page to load, including images. */
	$(window).load(function () {
		initPhotogallery(); // initialize the photogallery
		$(".owl-carousel").owlCarousel({
			autoplay: true,
			nav: true,
			dots: false,
			loop: false,
			margin:15,
			lazyLoad: true,
			autoplayHoverPause: true,
			responsive:{
				0:{
					items:1
				},
				600:{
					items:3
				}
			},
			navText:['<i class="fa fa-chevron-left" aria-hidden="true"></i>','<i class="fa fa-chevron-right" aria-hidden="true"></i>']
		});
		setEqHeight();
		openSlideContainers();
		scrollToOnLoadDirective();
	});

	/* --- window resizing --- */

	$(window).resize(function () {
		// resize and/or reposition elements here
		fixMobileTables();
		setEqHeight();
		responsiveTable();
	});
});


/* --- Non-jQuery functions below --- */

//check if just one checkbox is checked
function isChecked(formId, message) {
	var form = document.getElementById(formId);

	for (i = 0; i < form.elements.length; i++) {
		if (form.elements[i].checked == true) {
			return true;
		}
	}
	alert(message);
	return false;
}

//mail decode
var mDec = function mDec(ensl, enlsShow, addToHref, insertHtml) {
	if (enlsShow == undefined || enlsShow == "") {
		enlsShow = ensl;
	}

	if (addToHref == undefined) {
		addToHref = "";
	}

	let a = "pdlowr=" + ensl;
	let nslv = "";
	for (let i = 0; i < a.length; i++) {
		let n = a.charCodeAt(i) - 3;
		nslv += String.fromCharCode(n);
	}

	let s = "";
	for (let i = 0; i < enlsShow.length; i++) {
		let n = enlsShow.charCodeAt(i);
		if (n >= 35 && n <= 126) {
			s += String.fromCharCode(n - 3);
		} else {
			s += enlsShow.charAt(i);
		}
	}

	if (insertHtml == '') {
		insertHtml = s;
	}
	
	let title=nslv.replace('mailto:', '');

	document.write("<a class=\"email\" title=\"" + title + "\" href=\"" + nslv + addToHref + "\">" + insertHtml + "</a>");
};


/*
 * function get elements by class name ... simiar to getElementsByTagName
 * leave container arg out, and will default to document.
 */
function getElementsByClassName(className, container) {
	if (!container) {
		container = document;
	}
	if (container.all) {
		var all = container.all;
	} else {
		var all = container.getElementsByTagName('*');
	}
	var arr = [];
	for (var k = 0; k < all.length; k++) {
		if (all[k].className == className) {
			arr[arr.length] = all[k];
		}
	}
	return arr;
}

/*
 * Closes a tree of uls/lis (a menu for example) if scripts are enabled. Else leaves
 * the list open, so it is accessible to other users.
 * Note: this could be done in jQuery, but the list needs to close
 * as soon as it is loaded, so jQuery is not an option here.
 */
function closeList(listId, sublevelsClassName, closeAtLevel) {
	var list = document.getElementById(listId);

	for (var i = closeAtLevel; i < 5; ++i) {
		var aUls = getElementsByClassName(sublevelsClassName + i, list);
		for (var j = 0; j < aUls.length; ++j) {
			if (aUls[j].tagName == 'UL') { // only close ULs
				aUls[j].style.display = "none";
			}
		}
	}
}

/*
 * Closes any element by ID
 */
function hideElementById(elId) {
	var el = document.getElementById(elId);
	el.style.display = "none";
}


if (document.getElementsByTagName) {
	var inputElements = document.getElementsByTagName("input");
	for (var i = 0; inputElements[i]; i++) {
		if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
			inputElements[i].setAttribute("autocomplete", "off");
		}
	}
}



window.captchaCallback = captchaCallback;
window.urlDirFull = urlDirFull;
window.pageLng = pageLng;
window.initilizeLanguageSettings = initilizeLanguageSettings;
window.initializeAutoComplete = initializeAutoComplete;
window.setEqHeight = setEqHeight;
window.viewport = viewport;
window.openSlideContainers = openSlideContainers;
window.bindSlideAnchor = bindSlideAnchor;
window.scrollToOnLoadDirective = scrollToOnLoadDirective;
window.isChecked = isChecked;
window.mDec = mDec;
window.getElementsByClassName = getElementsByClassName;
window.closeList = closeList;
window.hideElementById = hideElementById;
window.inputElements = inputElements;
window.i = i;
}.call(window, window);